<div class="phone-input-container">
    <input
        #phoneInput
        digitOnly
        inputmode="numeric"
        type="text"
        [maxLength]="phoneNumberMaxLength"
        [pattern]="DIGIT_ONLY_PATTERN"
        [ngClass]="inputClass"
        [placeholder]="placeholder"
        (keyup)="checkPhoneValidation()" />
</div>
